import React from 'react';
import { ProfileBanner } from 'src/features/common/profile/components/profile-banner';
import { Spacing } from 'src/ui/common/atoms/spacing';
import { EntityLayoutAvatar } from './entity-layout-avatar';
import { EntityLayoutContainer } from './entity-layout-container';
import { EntityLayoutDescription } from './entity-layout-description';
import { EntityLayoutSocials } from './entity-layout-socials';
import { EntityLayoutTitle } from './entity-layout-title';
import { IEntityLayout } from './entity-layout.types';

export const EntityLayout: IEntityLayout = ({ children }) => (
    <Spacing mb="40px" mbSm="42px" mbMd="56px">
        {children}
    </Spacing>
);

EntityLayout.Banner = ProfileBanner;
EntityLayout.Avatar = EntityLayoutAvatar;
EntityLayout.Socials = EntityLayoutSocials;
EntityLayout.Container = EntityLayoutContainer;
EntityLayout.Title = EntityLayoutTitle;
EntityLayout.Description = EntityLayoutDescription;
